import React from "react";
import { StyleSheet, View, Text, Image } from "react-native";

import RenderIf from "./RenderIf";
import { colors } from "../components/Shared";
import { PersonIcon } from "./Icons";

interface Props {
  title?: string;
  message?: string;
  lastMessageDate?: any;
  me?: boolean;
  read: boolean;
  image?: string;
  selected?: string;
  id?: string;
  type: "RECRUITMENT" | "CONSULTING";
}
export default function HomeScreenChatItem({
  title,
  message,
  lastMessageDate,
  me,
  read,
  image,
  selected,
  id,
  type
}: Props) {
  // const image="https://live.mrf.io/statics/i/ps/www.muylinux.com/wp-content/uploads/2014/09/mountain1.jpg?width=1200&enable=upscale";
  return (
    <View
      style={[styles.container, { backgroundColor: selected === id ? "#efefef" : "#fff" }]}
    >
      <View style={{ justifyContent:'center', alignItems:'center', width: 50 }}>
        {image === "icon" ? (
          <PersonIcon color="#000" />
        ) : (
          <Image style={styles.image} source={{ uri: image }} />
        )}
        {!me && !read && <View style={styles.imagePod}></View>}
      </View>
      <View style={styles.body}>
        <Text style={styles.name}>{title}</Text>
        <Text style={styles.message}>
          {me ? "you: " : ""}
          {message}
        </Text>
      </View>
      <View>
        <Text style={styles.time}>{lastMessageDate}</Text>
        <RenderIf condition={type != undefined}>
            <View
                style={{
                    marginTop: 5,
                    backgroundColor: type == 'CONSULTING' ? '#cdcdcd' : colors.bg.primary,
                    padding: 5,
                    borderRadius: 5
                }}
            >
                <Text style={{ fontSize: 10 }}>{type?.charAt(0) + type?.substr(1).toLocaleLowerCase()}</Text>
            </View>
        </RenderIf>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 70,
    borderColor: "#D8D8D8",
    borderBottomWidth: 1,
    padding: 10,
    flexDirection: "row",
    overflow: 'hidden'
  },
  image: {
    width: 50,
    height: 50,
    borderRadius: 50,
  },
  imagePod: {
    width: 18,
    height: 18,
    borderRadius: 10,
    backgroundColor: colors.bg.green,
    position: "absolute",
    borderWidth: 2,
    borderColor: "#fff",
    top: -3,
    right: -3,
  },
  body: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
    paddingVertical: 5,
    paddingHorizontal: 10,
  },
  name: {
    fontSize: 15,
    fontWeight: "400",
    color: "#000",
    textTransform: "capitalize"
  },
  message: {
    color: "#c4c4c4",
  },
  time: {
    color: "#D8D8D8",
  },
});
